import { colors } from '@99designs/emu/settings';
import type { ContestTier } from './types';

export const getContestTierColor = (string: string | undefined): string => {
    let contestTierColor = colors.grey800;

    if (string === 'bronze') {
        contestTierColor = colors.packages.bronze;
    } else if (string === 'silver') {
        contestTierColor = colors.packages.silver;
    } else if (string === 'gold') {
        contestTierColor = colors.packages.gold;
    } else if (string === 'platinum') {
        contestTierColor = colors.packages.platinum;
    }

    return contestTierColor;
};

export const getContestTier = (string: string): ContestTier | undefined => {
    const lowerCaseString = string.toLowerCase();

    let contestTier = undefined;

    if (lowerCaseString.includes('bronze')) {
        contestTier = 'bronze' as ContestTier;
    } else if (lowerCaseString.includes('silver')) {
        contestTier = 'silver' as ContestTier;
    } else if (lowerCaseString.includes('gold')) {
        contestTier = 'gold' as ContestTier;
    } else if (lowerCaseString.includes('platinum')) {
        contestTier = 'platinum' as ContestTier;
    }

    return contestTier;
};

export const getContestTierName = (tier: ContestTier | undefined): string | undefined => {
    switch (tier) {
        case 'bronze':
            return __('Bronze');
        case 'silver':
            return __('Silver');
        case 'gold':
            return __('Gold');
        case 'platinum':
            return __('Platinum');
        default:
            return undefined;
    }
};
